import React from "react";
import Stepper from "./Stepper.js";
import { formatarCnpjCpf } from "../utils/documento.js";
import { resolverIdentificacaoPrograma } from "../utils/tipoPrograma.js";
import {
  extrairIdItem,
  resolverCnpjItem,
  resolverNomeAprendiz,
} from "../utils/itemResolvers.js";
import { obterTipoProgramaItem } from "../mappers/empresaMapper.js";

export const IdentificacaoCard = ({
  itemSelecionado,
  tipoProgramaSelecionado,
  tipoProgramaLogado,
  statusItem,
  etapasExemplo,
}) => {
  const etapaAtual = statusItem?.etapaAtual ?? 1;

  const cnpjResolvido = itemSelecionado
    ? resolverCnpjItem(itemSelecionado)
    : "";
  const docCnpj = cnpjResolvido ? formatarCnpjCpf(cnpjResolvido) : "—";

  const programa = itemSelecionado
    ? resolverIdentificacaoPrograma(
        itemSelecionado.raw || itemSelecionado,
        cnpjResolvido,
      )
    : null;

  const nomeAp = itemSelecionado ? resolverNomeAprendiz(itemSelecionado) : "";

  const tpSel = itemSelecionado
    ? (obterTipoProgramaItem(itemSelecionado) ??
      Number(tipoProgramaSelecionado ?? tipoProgramaLogado))
    : Number(tipoProgramaLogado);

  const statusStr = String(
    statusItem?.chave ||
    statusItem?.statusLabel ||
    itemSelecionado?.status ||
    itemSelecionado?.raw?.status ||
    ""
  ).toUpperCase();

  const ehStatusAprendizOuEstudante =
    statusStr.includes("APRENDIZ") ||
    statusStr.includes("ESTUDANTE") ||
    statusStr.includes("EM_PREENCHIMENTO");

  const totalRaw = Number(
    statusItem?.totalEtapas ??
    itemSelecionado?.total_etapas ??
    itemSelecionado?.raw?.total_etapas
  );

  const isEstagio = Number(tpSel) === 0;
  const isTca1 =
    Number(tpSel) === 1 && !ehStatusAprendizOuEstudante && totalRaw !== 5;

  let statusLabel = statusItem?.statusLabel || "";
  if (isEstagio) {
    if (
      /aprendiz/i.test(statusLabel) ||
      /aguardando preenchimento/i.test(statusLabel) ||
      /em preenchimento/i.test(statusLabel)
    ) {
      statusLabel = "Aguardando Preenchimento do Estagiário";
    }
  } else if (Number(tpSel) === 2) {
    if (/estagi[aá]rio/i.test(statusLabel)) {
      statusLabel = statusLabel.replace(/estagi[aá]rio/gi, "Aprendiz");
    }
  }

  const rotuloPessoa = isEstagio
    ? "Estagiário:"
    : /estudante/i.test(statusLabel) &&
        !itemSelecionado?.nome_aprendiz &&
        !itemSelecionado?.raw?.nome_aprendiz
      ? "Estudante:"
      : "Aprendiz:";

  if (!itemSelecionado) return null;

  return (
    <section className="acompanhamento-stepper-card">
      <div className="identificacao-bar">
        {itemSelecionado && (
          <div className="identificacao-item">
            <span className="identificacao-label">Formulário:</span>
            <span
              className="identificacao-valor"
              style={{
                fontWeight: 700,
                color: "#0369a1",
                backgroundColor: "#e0f2fe",
                padding: "2px 8px",
                borderRadius: 6,
                border: "1px solid #bae6fd",
                fontSize: 12,
              }}
            >
              #{extrairIdItem(itemSelecionado)}
            </span>
          </div>
        )}

        <div className="identificacao-item">
          <span className="identificacao-label">CNPJ:</span>
          <span className="identificacao-valor">
            {itemSelecionado ? (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                <span>{docCnpj}</span>
                {programa && (
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 10px",
                      borderRadius: 999,
                      fontSize: 11,
                      fontWeight: 600,
                      color: "#721c24",
                      backgroundColor: "#f8d7da",
                      border: "1px solid #721c24",
                      letterSpacing: 0.2,
                    }}
                  >
                    {programa.rotulo}
                  </span>
                )}
              </span>
            ) : (
              "—"
            )}
          </span>
        </div>

        {itemSelecionado && !isTca1 && nomeAp && (
          <div className="identificacao-item">
            <span className="identificacao-label">{rotuloPessoa}</span>
            <span
              className="identificacao-valor"
              style={{ fontWeight: 600, color: "#0f172a" }}
            >
              {nomeAp}
            </span>
          </div>
        )}

        {statusItem && (
          <div className="identificacao-item">
            <span
              className="status-badge"
              style={{
                backgroundColor: statusItem.statusCor + "22",
                color: statusItem.statusCor,
              }}
            >
              {statusLabel}
            </span>
          </div>
        )}
      </div>

      {itemSelecionado && (
        <Stepper
          etapaAtual={etapaAtual}
          etapas={(etapasExemplo || []).map((et) => {
            if (et.id === 2 && /estudante/i.test(statusLabel)) {
              return { ...et, nome: statusLabel };
            }
            return et;
          })}
          tipoPrograma={isEstagio ? 0 : tpSel}
        />
      )}
    </section>
  );
};

export default IdentificacaoCard;
